import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=56ba5c4f&scoped=true&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ba5c4f",
  null
  
)

export default component.exports